export default "__VITE_ASSET__DCVXFHQi__"